import { useTranslation } from 'react-i18next';

export default function WhyChooseUs() {
  const { t } = useTranslation();
  
  const reasons = [
    {
      icon: 'ri-award-line',
      title: t('why.certified.title'),
      description: t('why.certified.desc')
    },
    {
      icon: 'ri-team-line',
      title: t('why.experience.title'),
      description: t('why.experience.desc')
    },
    {
      icon: 'ri-leaf-line',
      title: t('why.eco.title'),
      description: t('why.eco.desc')
    },
    {
      icon: 'ri-tools-line',
      title: 'Gelişmiş Ekipman',
      description: 'Son teknoloji temizlik teknolojisi ve ekipmanları, operasyonlarınıza minimum müdahale ile verimli, kapsamlı temizlik sağlar.'
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Esnek Programlama',
      description: 'Özelleştirilmiş temizlik programları ile işletme saatlerinize uygun çalışıyoruz. Acil servisler ve özel talepler için 7/24 hizmet veriyoruz.'
    },
    {
      icon: 'ri-shield-check-line',
      title: t('why.insured.title'),
      description: t('why.insured.desc')
    },
    {
      icon: 'ri-customer-service-2-line',
      title: t('why.quality.title'),
      description: t('why.quality.desc')
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Rekabetçi Fiyatlandırma',
      description: 'Gizli ücret olmayan şeffaf fiyatlandırma. Kaliteden ödün vermeden bütçenize uygun özelleştirilmiş paketler sunuyoruz.'
    }
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            {t('why.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('why.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {reasons.map((reason, index) => (
            <div key={index} className="text-center">
              <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${reason.icon} text-4xl text-teal-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{reason.title}</h3>
              <p className="text-gray-600 leading-relaxed">{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}